<template>
  <div>
    <Card>
      <tables ref="tables" editable searchable search-place="top" v-model="tableData" :columns="columns" @on-delete="handleDelete"/>
      <Pager :total="this.total" @on-page-change="onPageChange"/>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import Pager from '_c/pager'
import { getArticleList, deleteArticle } from '@/api/data'
export default {
  name: 'article_list_page',
  components: {
    Tables,
    Pager
  },
  data () {
    return {
      columns: [
        { title: 'ID', key: 'id', sortable: true, width: 80 },
        { title: '标题', key: 'title', sortable: false },
        { title: '作者', key: 'author', editable: false },
        { title: '阅读数', key: 'view_count', editable: false },
        { title: '状态', key: 'status_name', editable: false },
        { title: '创建时间', key: 'created_at' },
        {
          title: '操作',
          key: 'handle',
          align: 'center',
          button: [
            (h, params, vm) => {
              return [
                h('Button', {
                  props: {
                    type: 'text',
                    ghost: true
                  },
                  on: {
                    click: () => {
                      let title = params.row.title
                      this.$Modal.confirm({
                        title: '你确定要删除吗?',
                        content: `<p>删除<b style="margin-left:5px">${title}</b></p>`,
                        onOk: () => {
                          deleteArticle(params.row.id).then(resp => {
                            if (resp.data.ok) {
                              this.$Message.info('删除成功')
                              this.onPageChange(this.page)
                            } else {
                              this.$Message.warning('删除失败')
                            }
                          })
                        },
                        onCancel: () => {
                          this.$Message.info('Clicked cancel')
                        }
                      })
                    }
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-trash',
                      size: 18,
                      color: '#000000'
                    }
                  })
                ]),
                h('Button', {
                  props: {
                    type: 'text',
                    ghost: true
                  },
                  on: {
                    click: () => {
                      let id = params.row.id
                      this.$router.push('/article/edit/' + id)
                    }
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: 'md-create',
                      size: 18,
                      color: '#000000'
                    }
                  })
                ])
              ]
            }
          ]
        }
      ],
      tableData: [],
      total: 0,
      page: 1
    }
  },
  methods: {
    handleDelete (params) {
      console.log(params)
      return false
    },
    onPageChange (page) {
      this.page = page
      getArticleList(page, 10).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    }
  },
  mounted () {
    getArticleList(1, 10).then(res => {
      this.tableData = res.data.list
      this.total = res.data.total
    })
  }
}
</script>

<style>

</style>
